<template>
  <div id="header">
    <div class="view-width">
      <!-- PC -->
      <div v-if="!isMobile" class="nav-container">
        <!-- logo -->
        <div class="logo">
          <img :src="assets.logo" alt="API Gateway" @click="goIndex" />
        </div>
        <!-- PC nav -->
        <nav class="nav">
          <menu-list></menu-list>
          <user></user>
        </nav>
      </div>
      <!-- mobile -->
      <div v-else class="nav-container nav-container__mobile">
        <!-- mobile nav -->
        <nav class="nav">
          <div class="logo">
            <img :src="assets.logo" style="height: 40px;" alt="API Gateway" @click="goIndex" />
          </div>
          <!-- shrink trigger -->
          <i class="trigger el-icon-menu" @click="showShrink"></i>
          <!-- 新需求：移动端暂时不展示用户信息 -->
          <user v-if="false"></user>
          <!-- shrink nav content -->
          <el-drawer
            class="shrink-menu"
            title="菜单"
            size="100vw"
            :visible.sync="hasShrink"
            :append-to-body="true"
            :with-header="true"
            :direction="'rtl'"
          >
            <menu-list @on-close="closeDrawer"></menu-list>
          </el-drawer>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { gotoIndex } from "@/libs/tools";
import MenuList from "./Menu";
import User from "./User";

export default {
  name: "pai-header",
  components: {
    "menu-list": MenuList,
    user: User
  },
  data() {
    return {
      assets: {
        logo: require("@/assets/logo.jpg"),
        new: require("@/assets/img/icons/new.png")
      },
      menu: "projectMenu",
      hasShrink: false
    };
  },
  computed: {
    ...mapGetters(["isMobile"])
  },
  methods: {
    ...mapMutations(["clearLocalStorage"]),

    // 跳转到首页
    goIndex() {
      gotoIndex();
    },

    showShrink() {
      this.hasShrink = true;
    },

    closeDrawer() {
      this.hasShrink = false;
    }
  }
};
</script>

<style lang="scss">
@import "./header.scss";
</style>
